import React, { useContext } from "react";
import { contactLinks } from "../constants";
import { ThemeContext } from "../themeProvider";

const Contact = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div
      id="contact"
      className={
        darkMode
          ? "bg-gray-100 pt-24 md:h-screen"
          : "bg-black pt-24 text-white md:h-screen"
      }
     style={{width:"85%",margin:"auto",height:"auto"}}
    >
      {/* className="max-w-7xl mx-auto x-4 sm:px-6 lg:px-8 px-4 " */}
      <div style={{width:"100%"}}>
        <h2 className="text-5xl font-bold px-4 md:px-0 text-center z-0">
          Contact
        </h2>
        <div>
          <h4 style={{margin:"1%"}}className="mt-12 text-3xl font-semibold text-blue-500">
            Connect with me
          </h4>
          <p style={{margin:"1%"}}className="text-gray-500 text-xl">
            If you want to know more about me or my work, or if you would just
            <br />
            like to say hello, send me a message. I'd love to hear from you.
          </p>
        </div>
        {/* className="flex justify-between items-center md:items-stretch  flex-col md:flex-row pb-24" */}
        <div >
          <div className="w-full md:pr-8">
            { 
             
               <form style={{margin:"1%"}}> 
                <button className="bg-indigo-500 text-white px-4 py-2 w-40 rounded-md hover:bg-indigo-400">
                  <a href="mailto:prathyu360@gmail.com">Send me an email</a>
                </button>
              {/* </div> */}
            </form> }
          </div>
          {/* className="w-full flex flex-col md:items-end  mt-12 md:mt-6" */}
          <div style={{marginTop:"2%",display:"flex",width:"100%",justifyContent:"space-around",flexDirection:"column",flexWrap:"wrap"}}>
            <div style={{display:"flex",gap:"5px",margin:"1%"}}>
            <h1 className="text-xl font-bold">Email: </h1>
            <a
              href="hello"
              // mb-12 mt-4
              className="mt-1 font-semibold text-blue-700 block uppercase"
            >
              prathyu360@gmail.com
            </a>
            </div>
            <div style={{display:"flex",gap:"5px",margin:"1%"}}>
            <h1 className="text-xl font-bold">Mobile:</h1>
            <a
              href="hello"
              className="mt-1 font-semibold text-blue-700 block uppercase"
            >
              8369740382
            </a>
            </div>
           
            <div style={{display:"flex",gap:"5px",margin:"1%"}}>
            <h1 className="text-xl  font-bold">Address:</h1>
            <a
              href="hello"
              // md:text-right
              className="mt-1  font-semibold text-blue-700 block uppercase"
            >
              Virar, Mumbai, India
            </a>
            </div>
            <div style={{display:"flex",gap:"5px",height:"auto",margin:"1%"}}>
            <h1 className="text-xl mt-3 font-bold">Social:</h1>
            <ul className="flex">
              {contactLinks.map((el) => (
                <a
                target="blank"
                  href={el.link}
                  // md:ml-6 md:mr-0 mr-6
                  className="mt-1  mr-6 cursor-pointer mt-4 hover:scale-125 flex flex-col justify-center items-center"
                >
                  <img alt="" src={el.url} />
                  {/* <p className="text-md mt-2 hover:hidden">{el.name}</p> */}
                </a>
              ))}
            </ul>
            </div>
            
          </div>
        </div>
      </div>
      {/* <div
        className={
          darkMode
            ? "w-full bg-white text-black text-lg py-3 flex justify-center md:mt-20"
            : "w-full bg-gray-900 text-white text-lg py-3 flex justify-center md:mt-20"
        }
      >
        Made with
        <div className="text-red-500 px-2 text-2xl">&#10084;</div>
        by Aakash Sharma
      </div> */}
    </div>
  );
};

export default Contact;
